import { categoryMeta, type VideoType } from "@/mocks/videos";

export function formatPlayCount(count: number): string {
  if (count >= 100000000) {
    return `${(count / 100000000).toFixed(1)}亿`;
  }
  if (count >= 10000) {
    return `${(count / 10000).toFixed(1)}万`;
  }
  return String(count);
}

export function typeLabel(type: VideoType): string {
  return categoryMeta[type]?.label ?? type;
}

export const typeOrder: VideoType[] = ["movie", "drama", "variety", "short"];